const _apiKeyV1Pattern: RegExp = /^ckey_([a-f0-9]{27})$/;
const _apiKeyV2Pattern: RegExp =
    /^cqt_(wF|rQ)([bcdfghjkmpqrtvwxyBCDFGHJKMPQRTVWXY346789]{26})$/;

export const isValidApiKey = (apiKey: string): boolean => {
    return _apiKeyV1Pattern.test(apiKey) || _apiKeyV2Pattern.test(apiKey);
};
